import React from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Label,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";

export default function BarCharts({
	data = [
		{ name: 0, sample1: 100, sample2: 200 },
		{ name: 1, sample1: 300, sample2: 400 },
	],
	xAxisBar = [
		{ dataKey: "sample1", fill: "#8884d8" },
		{ dataKey: "sample2", fill: "#82ca9d" },
	],
	dataKey = "name",
	header = { title: "Sample Title", details: "Sample details" },
	legendLayout = "vertical",
	legendVerticalAlign = "top",
	xAxislabel = (
		<Label value="Sample x Axis Label" offset={0} position="insideBottom" />
	),
	yAxisLabel = {
		value: "Sample y axis Label",
		angle: -90,
		position: "insideLeft",
	},
	yAxisDomain,
	customTooltipLabelFormatter,
	customTooltopValueFormatter,
	customLegendLayoutFormatter,
	customLegendContentFormatter,
}) {
	return (
		<ResponsiveContainer width="100%" height={500}>
			<div className="bg-primary-primaryYellow text-center justify-center flex flex-col items-center">
				<p className="font-bold text-xl">{header.title}</p>
				<p className="font-bold w-[95%] text-center w-100vw" style={{
					textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"
				}}>{header.details}</p>
			</div>
			<BarChart width={730} height={250} data={data}>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis dataKey={dataKey} style={{ marginTop: 5 }}>
					{xAxislabel}
				</XAxis>
				<YAxis label={yAxisLabel} domain={yAxisDomain} />
				<Tooltip
					labelFormatter={customTooltipLabelFormatter}
					formatter={customTooltopValueFormatter}
				/>
				<Legend
					layout={legendLayout}
					verticalAlign={legendVerticalAlign}
					formatter={customLegendLayoutFormatter}
					content={customLegendContentFormatter}
				/>
				{xAxisBar.map((data, key) => {
					return <Bar dataKey={data.dataKey} fill={data.fill} key={key} />;
				})}
			</BarChart>
		</ResponsiveContainer>
	);
}
